export default "__VITE_ASSET__BPsAuxKS__"